// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2wcST","choiceBoxes":"toolbarselects_choiceBoxes__2YNv9","simpleField":"toolbarselects_simpleField__3_hXJ"};